import {NgModule} from '@angular/core';
import {ExtraOptions, NavigationError, Router, RouterModule, Routes} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {WwComponentsComponent} from './pages/complete-shift/components/ww-components/ww-components.component';

import {filter} from 'rxjs/operators';

import {FeatureGuard} from 'projects/shared/src/lib/authentication/feature.guard';
import {AuthGuard} from 'projects/shared/src/lib/authentication/auth.guard';

import {MenuService} from 'projects/shared/src/lib/services/menu.service';

import {environment} from '@environment';

import {HomeComponent} from './pages/home/home.component';
import {InboundLoadsComponent} from './pages/inbound-loads/inbound-loads.component';
import {InboundLoadsFormComponent} from './pages/inbound-loads/form/form.component';
import {OutboundLoadsComponent} from './pages/outbound-loads/outbound-loads.component';
import {OutboundLoadsFormComponent} from './pages/outbound-loads/form/form.component';
import {InventoryComponent} from './pages/inventory/inventory.component';
import {PalletReclassificationComponent} from './pages/pallet-reclassification/pallet-reclassification.component';
import {CompleteShiftComponent} from './pages/complete-shift/complete-shift.component';
import {PieceRateFormComponent} from './pages/piece-rate-form/piece-rate-form.component';
import {LoadsSummaryComponent} from './pages/complete-shift/components/loads-summary/loads-summary.component';
import {
    InternalTransfersComponent
} from './pages/complete-shift/components/internal-transfers/internal-transfers.component';
import {
    ComponentsSummaryComponent
} from './pages/complete-shift/components/components-summary/components-summary.component';
import {SortSummaryComponent} from './pages/complete-shift/components/sort-summary/sort-summary.component';
import {ChepActivityComponent} from './pages/complete-shift/components/chep-activity/chep-activity.component';
import {
    EndOfShiftFilesComponent
} from './pages/complete-shift/components/end-of-shift-files/end-of-shift-files.component';
import {TrailersComponent} from "./pages/trailers/trailers.component";
import { QualityControlConfigComponent } from './pages/quality-control-config/quality-control-config.component';
import { QualityControlGuard } from '@shared/authentication/quality-control.guard';
import {HasSitesGuard} from "@shared/authentication/has-sites.guard";

const routes: Routes = [
    {
        path: '',
        data: {
            label: 'Warehousing',
            menuOrder: 1,
            link: 'Warehousing Home',
            roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
        },
        canActivate: [ AuthGuard, HasSitesGuard, FeatureGuard ],
        canActivateChild: [ AuthGuard, HasSitesGuard, FeatureGuard ],
        children: [ {
                path: 'trailers',
                data: {
                    label: 'Trailers',
                    menuOrder: 2,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                },
                component: TrailersComponent
            }, {
                path: 'loads/inbound',
                data: {
                    label: 'Inbound Loads',
                    menuOrder: 3,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                },
                children: [
                    {
                        path: 'new',
                        component: InboundLoadsFormComponent,
                        data: { label: 'Create', menuOrder: null },
                    }, {
                        path: ':id',
                        component: InboundLoadsFormComponent,
                        data: { label: 'Edit', menuOrder: null }
                    }, {
                        path: '',
                        component: InboundLoadsComponent,
                        data: { label: null, menuOrder: null }
                    }
                ]
            }, {
                path: 'loads/outbound',
                data: {
                    label: 'Outbound Loads',
                    menuOrder: 4,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                },
                children: [
                    {
                        path: 'new',
                        component: OutboundLoadsFormComponent,
                        data: { label: 'Create', menuOrder: null }
                    }, {
                        path: ':id',
                        component: OutboundLoadsFormComponent,
                        data: { label: 'Edit', menuOrder: null }
                    }, {
                        path: '',
                        component: OutboundLoadsComponent,
                        data: { label: null, menuOrder: null }
                    }
                ]
            }, {
                path: 'pallet-reclassification',
                data: {
                    label: 'Pallet Reclassification',
                    menuOrder: 5,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                },
                component: PalletReclassificationComponent
            }, {
                path: 'inventory',
                data: {
                    label: 'Daily Production',
                    menuOrder: 6,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                },
                component: InventoryComponent
            }, {
                path: 'complete-shift',
                data: {
                    label: 'Complete Shift',
                    menuOrder: 7,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                },
                component: CompleteShiftComponent,
                children: [
                    {
                        path: 'loads-summary',
                        component: LoadsSummaryComponent,
                        data: { label: 'Loads Summary', menuOrder: null }
                    },
                    {
                        path: 'summary/:id',
                        component: SortSummaryComponent,
                        data: { label: 'Storage', menuOrder: null }
                    },
                    {
                        path: 'internal-transfers',
                        component: InternalTransfersComponent,
                        data: { label: 'Internal Transfers', menuOrder: null }
                    },
                    {
                        path: 'components-summary/:id',
                        component: ComponentsSummaryComponent,
                        data: { label: 'Components Summary', menuOrder: null }
                    },
                    {
                        path: 'ww-components/:id',
                        component: WwComponentsComponent,
                        data: { label: 'WW Components', menuOrder: null }
                    },
                    {
                        path: 'end-of-shift-files',
                        component: EndOfShiftFilesComponent,
                        data: { label: 'End Of Shift Files', menuOrder: null }
                    },
                    {
                        path: 'chep-activity',
                        component: ChepActivityComponent,
                        data: { label: 'CHEP Activity', menuOrder: null }
                    },
                    {
                        path: '',
                        redirectTo: 'loads-summary',
                        pathMatch: 'full'
                    }

                ]
            },
            {
                path: 'piece-rate-form',
                data: {
                    label: 'Piece Rate Entry',
                    menuOrder: 8,
                    roles: [ 'scs site admin', 'scs admin', 'payroll', 'it', 'developers' ]
                },
                component: PieceRateFormComponent
            },
            {
                path: 'quality-control-config',
                data: {
                    label: 'QC Configuration',
                    menuOrder: 9,
                    roles: [ 'scs site admin', 'scs admin', 'it', 'developers' ],
                    requiresQualityControlAccess: true
                },
                component: QualityControlConfigComponent,
                canActivate: [ QualityControlGuard ],
            },
            {
                path: '',
                component: HomeComponent,
                data: {
                    label: 'Home',
                    menuOrder: null,
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
                }
            }
        ]
    }, {
        // The following three routes are required for MSAL redirects
        path: 'code',
        component: HomeComponent
    }, {
        path: 'error',
        component: HomeComponent
    }, {
        path: 'state',
        component: HomeComponent
    }
];

const routeSettings: ExtraOptions = {
    enableTracing: !environment.isProduction,
    useHash: true,
    relativeLinkResolution: 'legacy'
};

if (window !== window.parent && !window.opener)
    routeSettings.initialNavigation = 'disabled';
else
    routeSettings.initialNavigation = undefined;

@NgModule({
    imports: [
        RouterModule.forRoot(routes, routeSettings)
    ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {
    constructor(private router: Router, private menuService: MenuService, private title: Title) {
        this.menuService.Breadcrumbs.subscribe(breadcrumbs => {
            const segments = breadcrumbs.reduce((aggregate, current) => [ ...aggregate, current.label ], <string[]>[]);

            const t = segments.join(' / ');

            this.title.setTitle(`Vision - ${t}`);
        });

        this.router.events.pipe(filter(evt => evt instanceof NavigationError)).subscribe((event: NavigationError) => {
            console.error('Navigation Error');
            console.error({ event });
        });
    }
}
